import React from "react"
import {
  HStack,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
  VStack,
} from "@chakra-ui/react"
import { PrinterModelLabels } from "components/BadgeBuilder/utils/printers"
import { BadgeTemplate } from "sharedTypes/badge"

type Props = {
  template: BadgeTemplate
  onWidthChange: (width: number) => void
  onHeightChange: (height: number) => void
  isDisabled?: boolean
}

const GenericDimensionsForm = ({
  template,
  onWidthChange,
  onHeightChange,
  isDisabled = false,
}: Props) => {
  const { widthMm: width, heightMm: height } = template

  const handleWidthChange = (valueStr: string) => {
    const value = Number(valueStr)
    if (!Number.isNaN(value) && value > 0) {
      onWidthChange(Math.round(value))
    }
  }

  const handleHeightChange = (valueStr: string) => {
    const value = Number(valueStr)
    if (!Number.isNaN(value) && value > 0) {
      onHeightChange(Math.round(value))
    }
  }

  return (
    <VStack spacing={6} align="stretch">
      <VStack align="stretch" spacing={2}>
        <Text as="h2" fontSize="lg" fontWeight="semibold">
          {PrinterModelLabels[template.printerModel]}
        </Text>
        <Text color="gray.600">
          Create a badge of any size and export it as a PDF for custom printing.
        </Text>
      </VStack>

      <VStack align="stretch" spacing={4}>
        <Text as="h3" fontSize="md" fontWeight="semibold">
          Paper Size
        </Text>

        <VStack spacing={3} align="stretch">
          <HStack spacing={3} align="center">
            <Text fontSize="sm" fontWeight="medium" minW="60px">Width</Text>
            <NumberInput
              value={width}
              onChange={handleWidthChange}
              min={1}
              max={1000}
              step={1}
              precision={0}
              isDisabled={isDisabled}
              maxW="120px"
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
            <Text fontSize="sm" color="gray.600">mm</Text>
          </HStack>

          <HStack spacing={3} align="center">
            <Text fontSize="sm" fontWeight="medium" minW="60px">Height</Text>
            <NumberInput
              value={height}
              onChange={handleHeightChange}
              min={1}
              max={1000}
              step={1}
              precision={0}
              isDisabled={isDisabled}
              maxW="120px"
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
            <Text fontSize="sm" color="gray.600">mm</Text>
          </HStack>
        </VStack>
      </VStack>

    </VStack>
  )
}

export default GenericDimensionsForm
